import isEmpty from 'lodash.isempty';
import OrganizationServiceClient from '@/api/OrganizationServiceClient';

function expiresTTL() {
  return Date.now() + parseInt(import.meta.env.VITE_FEATURE_FLAG_TTL, 10) || (1000 * 60 * 20);
}

export default {
  namespaced: true,
  state: {
    dealerships: {},
    expire: expiresTTL(),
    selectedDealershipVal: -1, // why is this not preserved?
  },
  mutations: {
    setDealerAddresses(state, { dealershipId, addresses }) {
      state.dealerships[dealershipId] = addresses;
    },
    setExpire(state, expire) {
      state.expire = expire;
    },
    setSelectedDealership(state, orgId) {
      state.selectedDealershipVal = orgId;
    },
  },
  actions: {
    async getDealershipAddresses({
      commit,
      state,
      getters,
      rootGetters,
    }, dealershipId) {
      if (!isEmpty(state.dealerships[dealershipId])
        && state.expire > Date.now()) {
        return Promise.resolve(state.dealerships[dealershipId]);
      }
      if (!rootGetters.isAuthorized) {
        return Promise.resolve([]);
      }
      try {
        const organizationServiceClient = new OrganizationServiceClient(
          this.state.authorization.user,
        );
        const response = await organizationServiceClient.getDealershipAddresses(dealershipId);
        const { addresses } = response.data.data;
        commit('setDealerAddresses', {
          dealershipId,
          addresses,
        });
        commit('setExpire', getters.expiresFromNow);
        return addresses;
      } catch (error) {
        throw new Error(error.message);
      }
    },
    setSelectedDealership({
      commit,
    }, orgId) {
      commit('setSelectedDealership', orgId);
    },
  },
  getters: {
    expiresFromNow() {
      return expiresTTL();
    },
    getSelectedDealership(state) {
      return state.selectedDealershipVal;
    },
  },
};
